var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"letter-namings"},[_c('iframe',{staticClass:"mt-4",staticStyle:{"width":"100%","height":"550px"},attrs:{"src":"https://www.interventioncentral.org/rti2/letterNamings"}})])
}]

export { render, staticRenderFns }